import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './BlogPage.css';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await api.get('/api/blog-posts');
        setPosts(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching blog posts');
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const formatDate = (utcDate) => {
    const date = new Date(utcDate);
    return date.toLocaleString('en-CA', { timeZone: 'America/Toronto' });
  };

  return (
    <div className="blog-page-container">
      <h1>Latest Blog Posts</h1>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : posts.length === 0 ? (
        <p>No blog posts available.</p>
      ) : (
        <div className="blog-list">
          {posts.map((post) => (
            <div key={post._id} className="blog-item">
              <img src={post.image} alt={post.title} className="blog-image" />
              <h2>{post.title}</h2>
              <p className="blog-date">{formatDate(post.publishStart)}</p>
              <p className="blog-text">{post.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogPage;
